import { render, staticRenderFns } from "./wholeProcessList.vue?vue&type=template&id=0c2457f3&scoped=true&"
import script from "./wholeProcessList.vue?vue&type=script&lang=tsx&"
export * from "./wholeProcessList.vue?vue&type=script&lang=tsx&"
import style0 from "./wholeProcessList.vue?vue&type=style&index=0&id=0c2457f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2457f3",
  null
  
)

export default component.exports